<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
export default {
    components: {
        BFormGroup, BFormInput
    },
    props: {
        value: {
            type: [Number, null, undefined, ''],
            default: 0
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            weight: this.value
        };
    },
    watch: {
        value() {
            this.weight = this.value;
        }
    },
    computed: {
        isValid() {
            return this.weight !== null && this.weight !== undefined && this.weight !== '' && this.weight > 0;
        }
    }
}
</script>

<template>
    <b-form-group
        :label="$t('Component(Placeholder):product-weight')"
        label-for="productWeight"
    >
        <b-form-input
            type="number"
            id="productWeight"
            :class="{'input-bg-warning': required && !isValid}"
            :placeholder="$t('Component(Placeholder):product-weight')"
            v-model="weight"
            @change="$emit('input', weight)"
        />
    </b-form-group>
</template>

<style scoped lang="scss">

</style>
